var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_4298_3916)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M39.2033 10.3091C38.9772 9.45812 38.5315 8.68146 37.9109 8.05685C37.2902 7.43225 36.5165 6.9816 35.6669 6.75C32.5397 5.90909 20.0397 5.90909 20.0397 5.90909C20.0397 5.90909 7.53967 5.90909 4.4124 6.75C3.56289 6.9816 2.7891 7.43225 2.16849 8.05685C1.54787 8.68146 1.10218 9.45812 0.876037 10.3091C0.039673 13.45 0.0396729 20 0.0396729 20C0.0396729 20 0.039673 26.55 0.876037 29.6909C1.10218 30.5419 1.54787 31.3185 2.16849 31.9431C2.7891 32.5678 3.56289 33.0184 4.4124 33.25C7.53967 34.0909 20.0397 34.0909 20.0397 34.0909C20.0397 34.0909 32.5397 34.0909 35.6669 33.25C36.5165 33.0184 37.2902 32.5678 37.9109 31.9431C38.5315 31.3185 38.9772 30.5419 39.2033 29.6909C40.0397 26.55 40.0397 20 40.0397 20C40.0397 20 40.0397 13.45 39.2033 10.3091Z",
  fill: "#FF0302"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.9488 25.9478V14.0523L26.4033 20.0001L15.9488 25.9478Z",
  fill: "#FEFEFE"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4298_3916"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white"
})))));
export { SvgYoutube as ReactComponent };
export default __webpack_public_path__ + "static/media/youtube.0533d425.svg";